import type { Table } from "dexie";
import { BaseDexieRepository } from "./base-repository";
import type { AudioRecordingTranscriptChunkRecord } from "@/domains/dexie-db/models/audio-recording-legacy";

export class AudioRecordingLegacyTranscriptChunksRepository extends BaseDexieRepository<AudioRecordingTranscriptChunkRecord> {
  constructor(table: Table<AudioRecordingTranscriptChunkRecord, number>) {
    super({ tableRef: () => table });
  }

  async append({
    recordingId,
    noteId,
    channel,
    transcript,
    createdAt = Date.now(),
  }: {
    recordingId: string;
    noteId?: string;
    channel: number;
    transcript: AudioRecordingTranscriptChunkRecord["transcript"];
    createdAt?: number;
  }): Promise<void> {
    await this.table.add({ recordingId, noteId, channel, transcript, createdAt });
  }

  async listByRecordingId(recordingId: string): Promise<AudioRecordingTranscriptChunkRecord[]> {
    return this.table.where({ recordingId }).toArray();
  }

  async deleteByRecordingId(recordingId: string): Promise<void> {
    await this.table.where({ recordingId }).delete();
  }

  async deleteByRecordingIdAndChannel(recordingId: string, channel: number): Promise<void> {
    await this.table.where({ recordingId, channel }).delete();
  }

  async clearByNoteId(noteId: string): Promise<void> {
    await this.table.where({ noteId }).delete();
  }
}
